import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { AppFilter, ConfirmModal, ChatDocumentModal } from 'src/modules/shared';
import { FinanceService, OrganizationService } from '../../services';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { check } from 'src/modules/features/setting/modals';

interface IChatModalContext {
  data?: any;
}
@Component({
  selector: 'app-chat-modal',
  templateUrl: './chat-modal.component.html',
  styleUrls: ['./chat-modal.component.scss'],
})
export class ChatModalComponent {
  data;

  isAdmin: boolean;
  successMessage;
  messageIndex;
  collapse = false;
  replyBlock;
  createPending: boolean;
  createError: string;
  success: string;
  error: any;
  organization: any;
  user: any;
  organizationId: string;
  messages: Array<any> = [];
  pending: boolean;
  total;
  page;
  records;

  maxSize = 5;
  requireDocs = [];
  documents: any[] = [];
  documentsType: any[];
  attachment = false;
  attachmentSuccess = false;
  removeAttachemt: boolean;
  fileError: any;
  selectedFile: any;

  replyForm: FormGroup;
  fileObj: any;
  fileName: string;

  messageParams: AppFilter;
  searchMessagesFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'level',
        op: 'eq',
        data: 0,
      },
    ],
  };

  baseUrl = environment.API_SERVER;

  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'ownership_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'foreign_company_providers',
      },
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'contractor_relevant_docs',
      },
    ],
  };
  uploadFormData: any = new FormData();
  isReply: any;
  allowContractorToRespond: boolean = true;
  file: any;
  newComment: boolean;
  private unsubscribe$: Subject<void> = new Subject<void>();

  isEmojiPickerVisible: boolean = false;

  constructor(
    public modal: SuiModal<IChatModalContext, void, void>,
    private modalService: SuiModalService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private userService: OrganizationService,
    private sanitizer: DomSanitizer,
    private router: Router,
    private commentService: FinanceService,
    @Inject(DOCUMENT) private document
  ) {
    this.data = modal.context.data;
    localStorage.setItem('objectId', this.data);

    this.replyForm = fb.group({
      comment: ['', Validators.required],
      hideFromApplicant: [false],
    });

    if (window.localStorage.getItem('isAdmin')) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }

    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.organizationId = window.localStorage.getItem('organizationId');
    this.user = JSON.parse(window.localStorage.getItem('user'));
    if (this.user && this.user.image) {
      this.user.image = `${
        this.baseUrl
      }/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
    } else {
      this.user.image = 'assets/avatar/1.jpg';
    }

    // this.messageParams = new AppFilter({ sidx: 'dateCreated', rows: 4, sord: 'asc' });
    this.messageParams = new AppFilter({
      sidx: 'position',
      rows: 1000,
      sord: 'desc',
    });
    // this.searchMessagesFilter.rules[0].data = 0;
    // this.messageParams.filters = JSON.stringify(this.searchMessagesFilter);

    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((params) => {
        this.messages = [];
        this.getPage(1);
      });
  }

  onReply(event) {
    console.log(event);
    // this.replyForm.get('messageBody').patchValue('Reply to comment');
    this.isReply = event;
  }
  removeReply() {
    this.isReply = null;
  }
  removeFile() {
    this.fileObj = null;
    this.uploadFormData = new FormData();
  }
  showReplyForm(form) {
    this.replyBlock = form;
  }

  getPage(page) {
    this.messageParams.page = page;
    this.pending = true;

    console.log('fetching ewallet messages');
    this.commentService
      .getCommentsById({
        objectId: this.data,
        appUserId: this.user.appUserId,
        params: this.messageParams,
      })
      .pipe(
        map((result) => {
          result['rows'].forEach((comment) => {
            if (
              comment.objectType == ('WITHDRAWAL_REQUEST' || 'BANK_HISTORY')
            ) {
              comment['documentMetadata'] = comment['documentMetadata']
                ? JSON.parse(comment['documentMetadata'])
                : null;
            }
          });
          return result['rows'];
        })
      )
      .subscribe(
        (res) => {
          this.pending = false;
          res.forEach((comment) => {
            comment.comment = comment.comment.replace(
              /&(?:[a-z\d]+|#\d+|#x[a-f\d]+);/gi,
              ''
            );
            this.messages.unshift(comment);
          });
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  onScrollDown($event) {}

  onScrollUp($event) {
    if (!this.newComment) {
      let page = this.messageParams.page + 1;
      this.getPage(page);
    }
  }

  download(payload) {
    const url = `${this.baseUrl}/public/media/?media=${payload.filePath}`;
    window.open(url, '_blank');
  }

  send() {
    this.pending = true;

    if (this.replyForm.valid) {
      // console.log(this.filterMetaData);
      const formData = new FormData();
      if (this.fileObj) {
        formData.append('file', this.fileObj);
      }
      let data = this.replyForm.value;

      if (this.router.url.includes('/contractor/wallet/withdrawal-request')) {
        data['objectType'] = 'WITHDRAWAL_REQUEST';
      } else if (
        this.router.url.includes('/contractor/wallet/bank-change-request')
      ) {
        data['objectType'] = 'BANK_HISTORY';
      }
      data['hideFromApplicant'] = null;

      data.comment = data.comment.replace(/(<([^>]+)>)/gi, '');
      data.comment = data.comment.replace(
        /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi,
        ' '
      );
      if (this.isReply) {
        data['parentCommentId'] = this.isReply.commentId;
      }

      const blob = new Blob([JSON.stringify(data, null, 2)], {
        type: 'application/json',
      });

      // console.log(this.hideFromApplicant);
      formData.append('data', blob);

      console.log('send from ewallet');
      this.commentService
        .makeCommentById({
          objectId: this.data,
          body: formData,
        })
        .subscribe(
          (res) => {
            this.pending = false;

            // this.success = 'Message has been sent successfully'
            res['documentMetadata'] = res['documentId']
              ? JSON.parse(res['documentMetadata'])
              : '';
            // this.getPage(this.messageParams.page);

            this.messages.push(res);

            // this.messages += res;
            this.shouldScrollToBottom = true;
            this.fileObj = null;
            this.isReply = null;
            this.replyForm.reset();
          },
          (error) => {
            this.pending = false;
            this.error = 'Error uploading file!';
          }
        );
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  @ViewChild('scrollContainer') private myScrollContainer: ElementRef;

  ngOnInit() {
    this.checkAttach();
    this.scrollToBottom();
  }

  ngAfterViewChecked() {
    if (this.shouldScrollToBottom) {
      this.scrollToBottom();
    }
  }
  private shouldScrollToBottom = true;
  scrollToBottom(): void {
    console.log('newsweet');
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) {}
    this.shouldScrollToBottom = false;
  }
  uploadDoc($event) {
    this.fileObj = $event[0];
    this.fileName = this.fileObj['name'];
  }

  onFileChange(event) {
    const files = event.target.files;
    if (!files) {
      return;
    }
    this.selectedFile = files[0];
  }

  fileUpload() {
    const formData: FormData = new FormData();
    this.documents.forEach((doc) => {
      if (this.requireDocs.indexOf(doc.documentName)) {
        formData.append(doc.documentName, doc.file, doc.file.name);
      }
    });
    return formData;
  }

  checkAttach() {
    let ifAttach = false;
    if (this.fileObj != null) {
      ifAttach = true;
    } else {
      ifAttach = false;
    }
    return ifAttach;
  }

  addEmoji(event) {
    // this.replyForm.value.comment = `${this.replyForm.value.comment}${event.emoji.native}`;
    this.isEmojiPickerVisible = false;
  }
}

export class ChatModal extends ComponentModalConfig<
  IChatModalContext,
  void,
  void
> {
  constructor(size: ModalSize = ModalSize.Tiny, data?: any) {
    super(ChatModalComponent, { data: data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
